import { Config } from './config.default'
const localConfig: Partial<Config> = {}
export default localConfig
